import yup from "@/yup";

export function useSchema() {
  return yup.object({
    chooseBonusId: yup.number().integer().nullable().optional(),
    autoIssueBonusKioskDeposit: yup.boolean().optional(),
    autoIssueBonusPspDeposit: yup.boolean().optional(),
    autoIssueBonusStrategy: yup
      .mixed<"chooseBonus" | "autoHandleThreshold" | null>()
      .oneOf(["chooseBonus", "autoHandleThreshold", null])
      .nullable()
      .optional(),
    autoIssueBonusPspStrategy: yup
      .mixed<"chooseBonus" | "autoHandleThreshold" | null>()
      .oneOf(["chooseBonus", "autoHandleThreshold", null])
      .nullable()
      .optional(),
    chooseBonusPspId: yup.number().integer().nullable().optional(),
    // TODO use in two bonus strategy
    // bonuses: yup
    //   .array(yup.object({ bonusId: yup.number().integer().required() }))
    //   .nullable()
    //   .defined(),
  });
}

export type IAutoIssuesSchema = yup.InferType<ReturnType<typeof useSchema>>;
